import { useParams, useSearchParams } from "react-router-dom";
import { useWorkspace } from "contexts/WorkspaceContext";
import { websiteOwnerTypeForWorkspace } from "./websiteUtils";
import WebsiteBuildPortfolio from "components/websites/WebsiteBuildPortfolio";
import WebsiteBuildBusiness from "components/websites/WebsiteBuildBusiness";


export default function WebsiteBuild() {
  useParams();
  const [searchParams] = useSearchParams();
  const { selectedWorkspace, isOrganizationWorkspace } = useWorkspace();

  const ownerType = websiteOwnerTypeForWorkspace({
    isOrganizationWorkspace,
    selectedWorkspace,
    searchOwnerType: searchParams.get("ownerType"),
  });

  return ownerType === "PORTFOLIO" ? <WebsiteBuildPortfolio /> : <WebsiteBuildBusiness />;
}